module.exports = __webpack_public_path__ + "static/media/edit.e5746e61.png";